/* eslint-disable max-len */
// Copyright (c) 2023 Deere & Company

import * as busyCounter from '../../../sharedmodules/action-creators/busy-counter';
import { createSuccessMessage } from '../../../sharedmodules/action-creators/alert-messages';
import { putDuplicatePinPlate } from '../repositories';

import { readDuplicatePinPlate } from './get-duplicate-pin-plate';
import { translate } from '../../../sharedmodules/services/translation-service';

export const updateDuplicatePinPlateStatus = (getAccessToken, duplicatePinPlate) => async (dispatch) => {

    dispatch(busyCounter.increaseBusyCounter());

    try {

        await putDuplicatePinPlate(getAccessToken, duplicatePinPlate);

        dispatch(createSuccessMessage(translate('DUPLICATE_PIN_PLATE_REQUEST_UPDATED')));

        readDuplicatePinPlate(getAccessToken)(dispatch);

    } catch (error) {
    } finally {

        dispatch(busyCounter.decreaseBusyCounter());

    }

};
